import axios from "axios";
import envVariables from "../data/envVariables";
import { authConfig, checkedData } from "./portalApi";

const toNumber = (value) => {
    if (value == null || value === "") return 0;
    if (typeof value === "number") return value;
    return Number(String(value).replace(/,/g, "")) || 0;
};

const round2 = (n) => Math.round(n * 100) / 100;
const currencyKey = (code) => String(code || "").toLowerCase();
const withoutUplift = (amount, uplift) => amount / (1 + uplift / 100);

// Prices from get-search-results already include the uplift, so cost is the price with it taken off.
export const optionFromAircraft = (aircraft) => {
    const uplift = toNumber(aircraft.uplift);
    const operator = currencyKey(aircraft.operatorCurrency);
    const preferred = currencyKey(aircraft.preferredCurrency) || operator;
    const salePrice = toNumber(aircraft.price?.[preferred] ?? aircraft.price?.[operator]);
    return {
        tailNumber: aircraft.tailNumber,
        uplift: round2(uplift),
        salePrice: round2(salePrice),
        margin: round2(salePrice - withoutUplift(salePrice, uplift)),
        costPrice: round2(withoutUplift(toNumber(aircraft.price?.[operator]), uplift)),
        hidden: aircraft.show === false,
        recommended: !!aircraft.recommended,
        isManualQuote: !!aircraft.isManualQuote,
    };
};

// Applies an edit of either the sale price or the uplift and returns the recalculated option.
export const applyPricingEdit = (option, { salePrice, uplift }) => {
    const cost = option.salePrice - option.margin;
    const nextUplift =
        salePrice != null && salePrice !== "" ? (cost ? (toNumber(salePrice) / cost - 1) * 100 : 0) : toNumber(uplift);
    const nextSale = cost * (1 + nextUplift / 100);
    return {
        ...option,
        uplift: round2(nextUplift),
        salePrice: round2(nextSale),
        margin: round2(nextSale - cost),
    };
};

export const releaseQuoteToCustomer = async (legId, token) =>
    checkedData(
        await axios.post(
            `${envVariables.apiEndpoint}/api/flight/final-release-quote`,
            { LegId: legId },
            authConfig(token)
        ),
        "Quote could not be released"
    );

export const storeQuotePrices = async ({ legId, memberId, options }, token) =>
    checkedData(
        await axios.post(
            `${envVariables.apiEndpoint}/api/flight/store-quote-prices`,
            {
                LegId: legId,
                MemberId: memberId,
                RfqIds: options.map((option) => ({
                    tailNumber: option.tailNumber,
                    uplift: String(option.uplift),
                    price: option.salePrice.toFixed(2),
                    IsManualQuote: option.isManualQuote,
                    recommended: option.recommended,
                    show: !option.hidden,
                })),
            },
            authConfig(token)
        ),
        "Quote prices could not be saved"
    );
